"use client";
import { useEffect, useRef, useState } from "react";
import Link from "next/link";
import { useRouter, usePathname } from "next/navigation";
import { LogOut } from "lucide-react";
import { getUser, clearUser } from "@/lib/auth";

export default function NavBar() {
  const router = useRouter();
  const pathname = usePathname();
  const [user, setUser] = useState<string | null>(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setUser(getUser());
  }, [pathname]);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const logout = () => {
    clearUser();
    setUser(null);
    setMenuOpen(false);
    router.push("/");
  };

  return (
    <header className="absolute top-0 left-0 right-0 z-30 h-14">
      <div className="w-full px-8 h-full flex items-center justify-between">
        <Link
          href={user ? "/dashboard" : "/"}
          className="flex items-center gap-2 bg-white/70 backdrop-blur-md rounded-xl px-2.5 py-1.5 shadow-sm hover:bg-white/90 transition-all"
        >
          <img src="/flintly-wordmark.png" alt="Flintly" className="h-7 w-auto object-contain" />
        </Link>

        <div className="flex items-center gap-2.5">
          {user && (
            <Link
              href="/dashboard"
              className="text-sm font-semibold text-gray-700 hover:text-gray-950 bg-white/70 backdrop-blur-md hover:bg-white/90 px-3.5 py-1.5 rounded-xl shadow-sm transition-all"
            >
              Dashboard
            </Link>
          )}
          {user && (
            <div className="relative" ref={menuRef}>
              <button
                onClick={() => setMenuOpen(o => !o)}
                className="flex items-center gap-2 bg-white/70 backdrop-blur-md hover:bg-white/90 px-3 py-1.5 rounded-xl shadow-sm transition-all"
              >
                <div className="w-6 h-6 bg-[#daf47b] rounded-full flex items-center justify-center">
                  <span className="text-gray-950 text-[11px] font-black uppercase">{user[0]}</span>
                </div>
                <span className="text-xs font-semibold text-gray-700">{user}</span>
              </button>

              {menuOpen && (
                <div className="absolute right-0 top-full mt-1.5 w-40 bg-white rounded-xl shadow-lg border border-gray-100 py-1 z-50">
                  <button
                    onClick={logout}
                    className="w-full flex items-center gap-2.5 px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
                  >
                    <LogOut className="w-3.5 h-3.5 text-gray-400" />
                    Log out
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
